// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters_block {
  background: white;
}
.filters_block_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.filters_block_dotted {
  height: 14px;
  width: 100%;
}
@media (min-width: 991px) {
  .filters_block_dotted {
    height: 20px;
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .filters_block_dotted {
    height: 11px;
  }
}
.filters_block_button {
  box-shadow: 0px -4px 55px 0px rgba(0, 0, 0, 0.2509803922);
  padding: 10px;
  padding-bottom: 63px;
}
@media (max-width: 992px) {
  .filters_block_button {
    padding-bottom: 63px;
  }
}
.filters_block_button ion-button {
  width: 100%;
}

ul {
  list-style-type: none;
  padding: 0px;
  padding-bottom: 70px;
}

h5 {
  padding: 10px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  text-decoration: none;
}
li .wrapper {
  padding: 15px;
  background: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
li .wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .wrapper .info_block p {
  padding: 0px 10px;
  color: black;
  font-family: AppFont, sans-serif;
}
li .wrapper .circle {
  width: 20px;
  height: 20px;
  content: " ";
  border: 2px solid black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
li .wrapper .circle .cirle_inner {
  width: 14px;
  height: 14px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .wrapper .circle .cirle_inner.selected {
  background: black;
  border-radius: 50%;
  transition: ease-in-out 0.3s;
}

.wrapper_blocker {
  margin: 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/filters-additional-options/filters-additional-options.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;AAEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAAR;AAGI;EACI,YAAA;EACA,WAAA;AADR;ACXE;EDUE;IAMI,YAAA;EADN;AACF;AAEY;EARR;IASY,YAAA;EACd;AACF;AAEI;EACI,yDAAA;EACA,aAAA;EAIA,oBAAA;AAHR;ACpBE;EDiBE;IAIQ,oBAAA;EAGV;AACF;AADQ;EACI,WAAA;AAGZ;;AACA;EACI,qBAAA;EACA,YAAA;EACA,oBAAA;AAEJ;;AACA;EACI,aAAA;AAEJ;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAGJ;AADI;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAER;AADQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AAGZ;AAFY;EACI,iBAAA;EACA,YAAA;EACA,gCAAA;AAIhB;AAAQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEZ;AAAY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAEhB;AADgB;EACI,iBAAA;EACA,kBAAA;EACA,4BAAA;AAGpB;;AAGA;EACI,gBAAA;AAAJ","sourcesContent":["@import \"../../theme/mixins.scss\";\n\n.filters_block {\n    background: white;\n    &_title {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 10px;\n\n    }\n    &_dotted {\n        height: 14px;\n        width: 100%;\n        // background: url('../../assets/icon/separator_doted.svg') no-repeat center center/ 100% 100%;\n        @include desktop {\n        // background: url('../../assets/losteria/separator_doted2.svg') no-repeat center center/ 100% 130%;\n        height: 20px;\n    \n            @media (max-height: 750px) {\n                height: 11px;\n            }\n        }\n    }\n    &_button {\n        box-shadow: 0px -4px 55px 0px #00000040;\n        padding: 10px;\n        @include mobile {\n            padding-bottom: 63px;\n        }\n        padding-bottom: 63px;\n        ion-button {\n            width: 100%;\n        }\n    }\n}\nul {\n    list-style-type: none;\n    padding: 0px;\n    padding-bottom: 70px;\n\n}\nh5 {\n    padding: 10px;\n}\nli {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 10px;\n    text-decoration: none;\n  \n    .wrapper {\n        padding: 15px;\n        background: white;\n        width: 100%;\n\n        display: flex;\n        align-items: center;\n        justify-content:flex-start;\n        .info_block {\n            border-radius: 20px;\n            display: flex;\n            align-items: center;\n            p {\n                padding: 0px 10px;\n                color: black;\n                font-family: AppFont, sans-serif;\n            }\n    \n        }\n        .circle {\n            width: 20px;\n            height: 20px;\n            content: ' ';\n            border: 2px solid black;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          \n            .cirle_inner {\n                width: 14px;\n                height: 14px;\n                content: ' ';\n                background: transparent;\n                border-radius: 50%;\n                &.selected {\n                    background: black;\n                    border-radius: 50%;\n                    transition: ease-in-out 0.3s;\n                }\n            }\n        }\n    }  \n}\n.wrapper_blocker {\n    margin: 0px 10px;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
